import { handleActions } from 'redux-actions'

import {
    GET_ALL_OWNERS,
} from '@/store/actions/dictionaries'

const initialState = {
    data: [],
}

export const reducer = handleActions(
    {
        [GET_ALL_OWNERS.SUCCESS]: (state, { payload }) => ({
            ...state,
            data: payload,
        }),
        [GET_ALL_OWNERS.ERROR]: (state) => ({
            ...state,
        }),
    },
    initialState,
)

export default reducer